module.exports = __webpack_public_path__ + "img/close.ef882181.svg";